import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { Utente } from 'src/app/models/rbac/Utente';
import { UtenteService } from 'src/app/services/utente.service';

@Component({
  selector: 'app-nuovo-account',
  standalone: true,
  templateUrl: './nuovo-account.component.html',
  styleUrls: ['./nuovo-account.component.scss'],
  imports: [ReactiveFormsModule]
})
export class NuovoAccountComponent implements OnInit {
  formAccount = new FormGroup({
    utente: new FormControl(''),
    nome: new FormControl(''),
    broker: new FormControl(''),
    numero: new FormControl(''),
    valuta: new FormControl('')
  })
  titolo: string = ''
  utenti: any[] = []
  nuovoAccount: any

  constructor(public modalRef: MdbModalRef<NuovoAccountComponent>,
    private servUtenti: UtenteService) { }

  ngOnInit(): void {
    this.servUtenti.getListaUtenti().subscribe((data: any) => {
      console.log(data)
      this.utenti = data['data']
    })
  }

  close() {
    let acc = this.formAccount.value
    /* this.utente.setUtente({
      email: u.email,
      nome: u.nome,
      cognome: u.cognome,
      confirmed: u.abilitato == '1',
    })
    if (typeof u.cf === 'string') {
      let ruolo = this.ruoli.find(r => r.id == u.ruolo)
      this.utente.tipoUtente.setTipoUtente(ruolo.id, ruolo.ruolo, ruolo.gerarchia)
    } */

    this.modalRef.close(acc)
  }
}
